module.exports = __webpack_public_path__ + "img/3.5552db46.png";